import React, {Component} from 'react';
import {
    ActivityIndicator,
    Modal,
    ScrollView,
    Text,
    View
} from '../../react-native-components-in-react/react-native-components-in-react';
import ChocoConfig from '../ChocoConfig';

import Input from './Input/Input';

import * as InputFunctions from './Input/InputFunctions';
import {BorderlessButton, ThemeButton} from "../../react-button-package/ButtonPackage";

const ChocoForm = (props) => {
    const formElementsArray = [];
    let generalError = null;

    if(props.lang)
        ChocoConfig.lang = props.lang;

    if (props.form.generalError && props.form.generalError.show) {
        generalError = (<Text style={{ fontSize: 18, color: "red", marginBottom: 15, textAlign: "center" }}>{props.form.generalError.text}</Text>)
    }

    for (let key in props.form.controls) {
        formElementsArray.push({
            id: key,
            config: props.form.controls[key],
            className: props.form.controls[key].className,
            name: props.form.controls[key].name,
            errorMessage: props.form.controls[key].errorMessage
        });
    }

    const form = formElementsArray.map(formElement => (
        <Input
            key={formElement.id}
            inputStyle={props.inputStyle}
            inputStyleTouched={props.inputStyleTouched}
            inputStyleBlured={props.inputStyleBlured}
            inputChangedHandler={(event) => {
                const updatedForm = InputFunctions.inputChangedHandler(props.form, event, formElement.id);

                props.onFormChange(updatedForm);
            }}
            {...formElement}
        />
    ));

    return (
        <View className={props.containerClassName + ' row'}>
            {form}
            {generalError}
        </View>
    );
}

export default ChocoForm;

export class FormModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        let shouldUpdate = false;

        if (!this.props)
            shouldUpdate = true;
        else if (this.props.isOpen != nextProps.isOpen) {
            shouldUpdate = true;
        } else if (this.props.isOpen) {
            shouldUpdate = true;
        }


        return shouldUpdate;
    }

    render() {
        let disabledStyle = {};

        if (!this.props.form.isValidForm) {
            disabledStyle = {
                opacity: .5
            }
        }

        return (
            <Modal
                transparent={true}
                visible={this.props.isOpen}
                onRequestClose={this.props.toggle}
                hideHeader={true}
            >
                <View style={{
                    flex: 1,
                    flexDirection: 'column',
                }}>
                    <View style={{
                        borderRadius: 16,
                        paddingBottom: 0
                    }}>
                        <ScrollView keyboardShouldPersistTaps={'always'} style={{ minHeight: 100 }}>
                            {this.props.title ?
                                <h1>
                                    {this.props.title}
                                </h1>
                            :
                                null
                            }
                            <ChocoForm
                                form={this.props.form}
                                onFormChange={this.props.onFormChange}
                            />
                            {this.state.loading ?
                                <ActivityIndicator style={{marginRight: 7}}/>
                                :
                                <View style={{flexDirection: 'row', justifyContent: 'flex-end'}}>
                                    <BorderlessButton
                                        text={this.props.cancelText}
                                        onPress={this.props.toggle}
                                    />
                                    <View style={{ width: 7 }}></View>
                                    <ThemeButton
                                        disabled={!this.props.form.isValidForm}
                                        text={this.props.confirmText}
                                        onPress={async () => {
                                            if (this.props.form.isValidForm) {
                                                this.setState({
                                                    loading: true
                                                });

                                                await this.props.confirmFunction();

                                                this.setState({
                                                    loading: false
                                                });
                                            }
                                        }}
                                    />
                                </View>
                            }
                        </ScrollView>
                    </View>
                </View>
            </Modal>
        );
    }

}